import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../../graphql/common.datatypes';

interface ForgotPasswordVars {
    data: {
      cellphone: string
      cellphone_code: string
    }
}

interface ForgotPasswordData {
  forgotPasswordSms: StatusMessage
}

export const FORGOT_PASSWORD_SMS_MUTATION = gql`
    mutation forgotPasswordSms($data: ForgotPasswordSmsInput!) {
        forgotPasswordSms(data: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const forgotPasswordSms = () => useMutation<ForgotPasswordData, ForgotPasswordVars>(
  FORGOT_PASSWORD_SMS_MUTATION, {}
);

export default forgotPasswordSms;
